import Nouislider from "nouislider-react";
import "./NumbeRange.scss";

import wNumb from 'wnumb';

export interface NumberRange {
	min: number;
	max: number;
}

export interface NumberRangeProps {
	range: NumberRange;
	value: NumberRange;
	formatter?: wNumb.Instance;
	onSelectedRangeChange?: (item: NumberRange) => void;
}

export const NumberRange = (props: NumberRangeProps) => {
	const tooltips = props.formatter !== undefined
		? [props.formatter, props.formatter]
		: undefined;

	return (
		<Nouislider
			range={props.range}
			start={[props.value.min, props.value.max]}
			connect={[false, true, false]} 
			tooltips={tooltips} 
			onChange={value => props.onSelectedRangeChange && props.onSelectedRangeChange({ min: parseFloat(value[0]), max: parseFloat(value[1])}) }/>
	);
};
NumberRange.percentFormatter = wNumb( { decimals: 2, suffix: '%', thousand: ' ' });
NumberRange.defaultFormatter = wNumb( { decimals: 0, thousand: ' ' });
NumberRange.decimalsFormatter = wNumb( { decimals: 2, thousand: ' ' });